import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[app-autocomplete-state-title]',
})
export class AutocompleteStateTitleDirective {
  // HostBinding
  @HostBinding('class') class = 'mt-4 font-semibold text-gray-900';
}
